/** @format */
import { AxiosResponse } from 'axios';
import { get } from 'lodash';

import { normalizeIsoCode } from '@toucan/common/helpers/language';

import { GeneralPageDataVariables } from '../types';

export function pageDataSerializer(response: AxiosResponse) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
    const [sectionData, otherData] = Object.keys(response.data.data).reduce(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
        (accumulator: any, key: string) => {
            const index = key === 'siteSectionCollection' ? 0 : 1;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
            accumulator[index] = get(response, `data.data.${key}.items`);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
            return accumulator;
        },
        [[], []]
    );

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    return {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
        ...sectionData.reduce((obj: any, data: any) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
            obj[data.key] = data.linkedFrom.entryCollection.items;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
            return obj;
        }, {}),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        OTHER: otherData,
    };
}

export function getGeneralPageDataVariables(
    siteSection: string[],
    locale: string
): GeneralPageDataVariables {
    return {
        siteSection,
        limit: siteSection.length,
        locale: normalizeIsoCode(locale),
        baseLocale: 'en-GB',
    };
}
